var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "0.666902in",
    height: "1.19369in",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1136.96 2035.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 169.2l-843.9 853.24 832.27 838.25c116.98,117.82 -27.36,237.4 -127.39,136.39l-965.34 -974.65 970.61 -987.06c100.22,-101.92 227.13,39.41 133.74,133.82z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollLeft);
export default __webpack_public_path__ + "static/media/scroll_left.449fd358bc749a25e0219edfc80aec42.svg";
export { ForwardRef as ReactComponent };